import { createApi } from '@reduxjs/toolkit/query/react'
import { hcPortalBaseQuery } from '@/features/baseQuery.ts'
import { EmployeeProfileLite } from '@/features/employee-data/employee-data.def.ts'
import {
  CreateMissingEmployeesInAuthServiceRequest, GetEmployeeDataAccessClaimRequest,
  GetOwnProfileRequest,
  MissingEmployeeInAuthService,
} from '@/features/user/user.def.ts'
import { EmployeeDataAccessClaim } from '@/features/employee-data/employee-profile.def.ts'


export const userApi = createApi({
  reducerPath: 'userApi',
  tagTypes: ['Profile', 'Approval', 'Checklist', 'EmployeeDataAccessClaim'],
  baseQuery: hcPortalBaseQuery(),
  endpoints: builder => ({
    getOwnProfile: builder.query<EmployeeProfileLite, GetOwnProfileRequest>({
      query: (request) => ({
        url: `/User/Profile/GetOwnProfile`,
        method: 'GET',
        cache: 'no-cache',
        params: request,
      }),
      providesTags: ['Profile'],
    }),
    getEmployeeDataAccessClaim: builder.query<EmployeeDataAccessClaim, GetEmployeeDataAccessClaimRequest>({
      query: (request) => ({
        url: `/User/Profile/GetEmployeeDataAccessClaim`,
        method: 'GET',
        cache: 'no-cache',
        params: request,
      }),
      providesTags: ['Profile'],
    }),
    runDataMigration: builder.mutation<void, void>({
      query: (request) => ({
        url: `/DataMigration/Run`,
        method: 'POST',
        cache: 'no-cache',
        body: request,
      }),
    }),
    scanMissingEmployeesInAuthService: builder.mutation<MissingEmployeeInAuthService[], void>({
      query: () => ({
        url: `/DataMigration/ScanMissingEmployeesInAuthService`,
        method: 'GET',
        cache: 'no-cache',
      }),
    }),
    createMissingEmployeesInAuthService: builder.mutation<void, CreateMissingEmployeesInAuthServiceRequest>({
      query: (request) => ({
        url: `/DataMigration/CreateMissingEmployeesInAuthService`,
        method: 'POST',
        cache: 'no-cache',
        body: request,
      }),
    }),
  }),
})

export const {
  useGetOwnProfileQuery,
  useGetEmployeeDataAccessClaimQuery,
  useRunDataMigrationMutation,
  useScanMissingEmployeesInAuthServiceMutation,
  useCreateMissingEmployeesInAuthServiceMutation,
} = userApi